import styled from "styled-components";

export const MusicHallRegisBookingStyled = styled.div`
  .datetime_text1 {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .datetime_text2 {
    margin-bottom: 5px;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .datetime_layout {
    margin-bottom: 27px;
  }
  .booked_slot_note {
    margin-top: 6px;
    color: #ff8900;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .legend_layout {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    .legend_item {
      display: flex;
      align-items: center;
      column-gap: 6px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      .legend_dot {
        flex-shrink: 0;
        box-sizing: border-box;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: transparent;
        &.busy {
          border: 2px solid #ff8900;
        }
        &.closed {
          border: 2px solid #ff0f00;
        }
        &.main_date {
          border: 2px solid #4b1e78;
        }
      }
    }
  }
  .alternative_layout {
    margin-bottom: 27px;
    /* ทำเป็นกล่อง เพื่อให้เห็นชัดว่าทุกช่องข้างในเป็นของวันสำรองใบนี้ ไม่ปนกับวันหลัก */
    .alternative_item {
      margin-bottom: 16px;
      border-radius: 12px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_7};
      padding: 16px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      .alternative_head {
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 8px;
        .alternative_remove {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
      .alternative_time_layout {
        margin-top: 16px;
      }
    }
    .alternative_errors {
      margin-bottom: 8px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      color: ${({ theme }) => theme.COLORS.RED_1};
    }
    .alternative_add {
      margin-left: auto;
      padding: 6px 16px;
      width: fit-content;
      border-radius: 21px;
      border: 0.5px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      cursor: pointer;
    }
  }
  /* ใช้วงกลมล้อมตัวเลขแทนการระบายพื้นเต็มช่อง ตัวเลขจะได้ไม่จม */
  .react-calendar__tile {
    abbr {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border: 2px solid transparent;
      border-radius: 50%;
    }
    &.tile_busy abbr {
      border-color: #ff8900;
      color: #ff8900;
    }
    &.tile_closed abbr {
      border-color: #ff0f00;
      color: #ff0f00;
    }
    &.tile_main_date abbr {
      border-color: #4b1e78;
      color: #4b1e78;
    }
  }
  /* กลบสีดีฟอลต์ของ react-calendar (วันนี้=เหลือง, วันที่เลือก=น้ำเงิน) ให้เข้าธีมม่วง */
  .react-calendar__tile--now,
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: transparent;
    abbr {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
  .react-calendar__tile--active,
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: transparent;
    abbr {
      border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
    }
  }
  /* ยกออกมาระดับบนสุด เพื่อให้ช่องเวลาของวันสำรองหน้าตาเหมือนของวันหลักเป๊ะ */
  .set_clean_text1 {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .set_clean_text2 {
    margin-bottom: 15px;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .time {
    .time_layout {
      margin-bottom: 11px;
      display: flex;
      align-items: center;
      column-gap: 40px;
      .time_text1,
      .time_text2 {
        width: 40px;
        padding-left: 20px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
      .time_input_wrap {
        flex: 1;
      }
    }
  }
  .set_clean_layout {
    margin-bottom: 27px;
  }
  .button_layout {
    padding: 10px 42px;
    display: flex;
    justify-content: center;
    column-gap: 36px;
    .button1 {
      flex: 1;
    }
    .button2 {
      flex: 1;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .button_layout {
      padding: 0;
      display: flex;
      column-gap: 16px;
    }
  }
`;
